// import { SnackbarContext } from "../../constant_components/providers/SnackbarProvider";
// import { useState, useContext } from "react";

import "./Statements.css";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import { useTranslation } from "react-i18next";

export const StatementSummaryNew = ({ stub, isCensored }) => {
  const { t } = useTranslation();
  // const { triggerSnackbar } = useContext(SnackbarContext);
  const censored = isCensored;
  // console.log(censored)

  const formatAmount = (amount) => {
    if (censored) {
      return amount.replace(/[0-9]/g, "X");
    }
    return amount;
  };

  return (
    <Box>
      <Box
        className="tm-stub-content-new"
        sx={{
          borderRadius: "0.25em",
          border: "1px solid #000",
          padding: "0.5em",
        }}
      >
        <Box
          className="tm-stub-header"
          sx={{
            flex: "3",
            fontSize: "1rem",
          }}
        >
          <h4>{t("statement.summary")}</h4>

          <Typography variant="body1">
            {stub && stub.type === "hourly"
              ? `${t("statement.hours")}: ${stub.total_hours}`
              : null}
          </Typography>
        </Box>
        <Box
          className="tm-stub-body"
          sx={{
            flex: "2",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
            fontSize: "0.75rem",
            marginRight: "2em",
          }}
        >
          <Typography variant="body1">
            $
            {stub && stub.net_pay
              ? formatAmount(stub.net_pay)
              : censored
              ? "XXX.XX"
              : t("statement.na")}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontSize: "0.6rem",
            }}
          >
            {t("statement.takeHome")}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontSize: "0.75rem",
            }}
          >
            {stub && stub.pay_date ? stub.pay_date : t("statement.na")}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
